<template>
  <div class="box">
    <div>
      <el-form :inline="true" :model="orderReceipt" ref="orderReceipt" class="demo-form-inline" size="mini">
        <el-form-item>
          <el-date-picker
            unlink-panels
            v-model="findDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerDate"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
            @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="orderReceipt.findUserId" clearable style="width: 90px;margin-right: 5px"  placeholder="找车人">
            <el-option label="全部" value="">
            </el-option>
            <el-option v-for="item in appInfo.userList" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>
            <el-option label="自己上车" value="2"></el-option>
            <el-option label="合车" value="3"></el-option>
          </el-select>
          <el-select v-model="orderReceipt.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">
            <el-option label="全部" value="">
            </el-option>
            <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
            </el-option>
          </el-select>
          <el-select v-model="orderReceipt.supplyId" clearable style="width: 90px;margin-right: 5px"  placeholder="经理">
            <el-option label="全部" value="">
            </el-option>
            <el-option v-for="item in appInfo.supplyList" :key="item.supplyId" :label="item.name" :value="item.supplyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-tag @click="toggleSecret" size="medium" type="info" style="cursor: pointer;" :class="!isSecret ? 'ldms-font ldms-xianshi' : 'ldms-font ldms-hide'" ></el-tag><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
        <el-button size="mini" type="primary" @click="excel" >导出Excel</el-button>
      </el-form>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="orderReceiptList.records"
        stripe
        :height="windowHeight"
        :summary-method="getSummaries"
        show-summary
        style="width: 100%;z-index: 1;font-size: 12px">
        <el-table-column
          width="110"
          label="日期"
          label-class-name="header">
          <template slot-scope="scope">
            <span>{{new Date(scope.row.createDate).format("yy-MM-dd HH点")}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="areaName"
          label="地点"
          :filters="filter"
          :filter-method="filterHandler"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          label="车主"
          label-class-name="header">
          <template slot-scope="scope">
            <p>{{scope.row.ownerName}}</p>
            <p>{{scope.row.address}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ownerPhone"
          label="电话"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          prop="carNumber"
          label="车牌"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          label="吨位"
          label-class-name="header">
          <template slot-scope="scope">
            <span>{{scope.row.tonnage}}吨</span>
          </template>
        </el-table-column>
        <el-table-column
          label="实际运费"
          label-class-name="header">
          <template slot-scope="scope">
            <span>{{scope.row.actualFreight+scope.row.priceUnit}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="freight"
          label="订车运费"
          label-class-name="header">
          <template slot-scope="scope">
            <span v-if="isSecret">{{scope.row.freight+scope.row.priceUnit}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="total"
          label="实际收款"
          label-class-name="header">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" v-if="isSecret">
              <p>信息费: {{ scope.row.cash }}元</p>
              <p>微信: {{ scope.row.weixin }}元</p>
              <p>垫款: {{ scope.row.advances }}元</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="mini" >{{ scope.row.total }}元</el-tag>
              </div>
            </el-popover>
            <div v-else slot="reference" class="name-wrapper">
              <el-tag size="mini">***</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="订车经理"
          width="110"
          label-class-name="header">
          <template slot-scope="scope">
            <el-select @change="changeSupply(scope.row)" size="mini"  v-model="scope.row.supplyId">
              <el-option v-for="item in appInfo.supplyList" :key="item.supplyId.toString()" :label="item.name" :value="item.supplyId.toString()">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="username"
          label="找车人"
          label-class-name="header">
        </el-table-column>
        <el-table-column
          label="备注/打印"
          label-class-name="header">
          <template slot-scope="scope">
              <el-popover v-if="scope.row.remark" trigger="hover" placement="top">
                <p>{{ scope.row.remark }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-button
                    size="mini"
                    type="info" @click="print(scope.row)">打印</el-button>
                </div>
              </el-popover>
            <el-button
              size="mini"
              type="info" v-else @click="print(scope.row)">打印</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          label-class-name="header">
          <template slot-scope="scope">
            <el-dropdown size="mini" @command="handleOrder">
              <el-button size="mini" type="primary">
                设置<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" size="mini">
                <el-dropdown-item :command="scope.row">修改</el-dropdown-item>
                <el-dropdown-item :command="[scope.row.receiptId,scope.row.orderId,scope.row.cargoId]">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <template slot=append v-if="carGroup.length>0">
          <div style="text-align:center;margin:10px;">
            <el-button v-for="item in carGroup"  :key="item.carId" :label="item.carNumber" :value="item.carNumber" size="mini" round  :type="item.groupId != groupId? 'danger' : 'primary' " plain  @click="group(item)" :disabled="orderReceiptList.records[0].carId == item.carId">{{item.carNumber}}</el-button>
            <el-divider content-position="center">相似车牌号：蓝色为一组，红色未分组，点击进行切换</el-divider>
          </div>
        </template>
      </el-table>
    </div>
    <div style="margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="orderReceiptList.current"
        :page-sizes="[15, 30, 50, 100, 300, 500, 10000]"
        :page-size="orderReceiptList.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="orderReceiptList.total">
      </el-pagination>
    </div>
    <receipt-order :fold="folds" :userList="appInfo.userList" :receiptOrder="param"  @hiden="hideFold"></receipt-order>
    <el-dialog title="取消" :visible.sync="deleteVisible" width="30%">
      <el-checkbox-group v-model="reasonArr" class="reason" @change="reason">
        <el-checkbox label="货主不要" ></el-checkbox>
        <el-checkbox label="司机不拉" ></el-checkbox>
        <el-checkbox label="司机换货" ></el-checkbox>
      </el-checkbox-group>
      <el-form :model="receiptOrderFrom" ref="receiptOrderFrom">
        <el-form-item label="取消原因" prop="reason" label-width="80px"
                      :rules="{required: true, message: '取消原因不能为空', trigger: 'blur'}">
          <el-input v-model="receiptOrderFrom.reason" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible=false">取 消</el-button>
        <el-button type="primary" @click="deleteReceiptOrder('receiptOrderFrom')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {receiptList, deleteReceiptOrder, updateReceiptSupply} from '../../../api/receiptOrder'
import { getAppInfo } from '../../../api/app'
import { carGroupByPhone, addCarGroup, deleteCarGroup } from '../../../api/car'
import receiptOrder from '../../../components/receiptOrder'
import { getPageInfo } from '../../../api/page'
import { export_json_to_excel } from '../../../vendor/Export2Excel'

export default {
  name: 'ReceiptOrderList',
  data () {
    return {
      timer: null,
      isSecret: false,
      deleteVisible: false,
      folds: false,
      param: null,
      appId: '',
      loading: true,
      windowHeight: '',
      orderReceiptList: {},
      appInfo: {},
      filter: [],
      receiptOrderFrom: {
        reason: '',
        isFlagCategory: '',
        cargoId: '',
        orderId: '',
        appid: '',
        receiptId: ''
      },
      reasonArr: [],
      orderReceipt: {
        pageSize: 15,
        current: 1,
        endDate: '',
        startDate: '',
        findUserId: null,
        categoryId: null,
        supplyId: null
      },
      carGroup: [],
      groupId: null,
      findDate: [],
      pickerDate: {
        shortcuts: [{
          text: '当日',
          onClick (picker) {
            const end = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            const start = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            end.setTime(start.getTime() + 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '当月',
          onClick (picker) {
            const end = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const start = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.appId = to.params.id
      vm.orderReceipt.appId = to.params.id
      getAppInfo(to.params.id).then((response) => {
        vm.appInfo = response.data.data
      })
      vm.getList(vm.orderReceipt, to.query.receiptId)
      vm.getPage(to.params.id)
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 308
  },
  methods: {
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map((j, i) => {
        if (0 === i) {
           return v[j] = new Date(v[j]).format("yyyy-MM-dd HH:mm:ss")
        } else {
          return v[j]
        }
        })
      )
    },
    excel () {
      const tHeader = ['时间', '地点', '实际运费', '订车运费', '吨位', '单位', '收款', '车牌号码', '司机', '电话', '地址', '经理', '经理电话']
      const filterVal = [
        'createDate',
        'areaName',
        'actualFreight',
        'freight',
        'tonnage',
        'priceUnit',
        'total',
        'carNumber',
        'ownerName',
        'ownerPhone',
        'address',
        'supplyName',
        'supplyPhone'
      ]
      const data = this.formatJson(filterVal, this.orderReceiptList.records)
      console.log(data)
      export_json_to_excel(tHeader, data, '配货单-' + new Date())
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    getCarList (appId, param) {
      let _this = this
      carGroupByPhone(appId, param).then((response) => {
        _this.carGroup = response.data.data.records
      })
    },
    toggleSecret () {
      this.isSecret = !this.isSecret
    },
    reason: function () {
      this.receiptOrderFrom.reason = this.reasonArr.join()
    },
    showReceiptOrder (item) {
      item.appId = this.orderReceipt.appId
      this.param = item
      this.folds = true
    },
    changeSupply (item) {
      let _this = this
      this.deleteVisible = false
      item.appId = _this.appId
      this.receiptOrderFrom.isFlagCategory = 1
      updateReceiptSupply(item.receiptId, item).catch(() => {
        item.supplyId = ''
      })
    },
    handleOrder (item) {
      if (item instanceof Array) {
        this.deleteReceiptOrderDialog(item[0], item[1], item[2])
        return
      }
      this.showReceiptOrder(item)
    },
    deleteReceiptOrderDialog (receiptId, orderId, cargoId) {
      this.reasonArr = []
      this.receiptOrderFrom.reason = ''
      this.deleteVisible = true
      this.receiptOrderFrom.cargoId = cargoId
      this.receiptOrderFrom.appId = this.appId
      this.receiptOrderFrom.orderId = orderId
      this.receiptOrderFrom.receiptId = receiptId
    },
    deleteReceiptOrder (publishForm) {
      let _this = this
      this.$refs[publishForm].validate((valid) => {
        if (valid) {
          this.$confirm('是否保留原货源?', '提示', {
            confirmButtonText: '保留',
            cancelButtonText: '不保留',
            type: 'warning'
          }).then(() => {
            this.deleteVisible = false
            this.receiptOrderFrom.isFlagCategory = 1
            deleteReceiptOrder(this.receiptOrderFrom.receiptId, this.receiptOrderFrom).then(() => {
              _this.getList(_this.orderReceipt)
              _this.deleteVisible = false
            })
          }).catch(() => {
            this.deleteVisible = false
            this.receiptOrderFrom.isFlagCategory = 0
            deleteReceiptOrder(this.receiptOrderFrom.receiptId, this.receiptOrderFrom).then(() => {
              _this.getList(_this.orderReceipt)
              _this.deleteVisible = false
            })
          })
        }
      })
    },
    changeDate (item) {
      if (item !== null) {
        this.orderReceipt.startDate = item[0]
        this.orderReceipt.endDate = item[1]
      } else {
        this.orderReceipt.startDate = null
        this.orderReceipt.endDate = null
      }
    },
    getPage (appId) {
      getPageInfo(appId).then(res => {
        res.data.data.appId = null
        localStorage.setItem('ldms_print_page', JSON.stringify(res.data.data))
      })
    },
    getList (pamar, receiptId) {
      let _this = this
      _this.loading = true
      setTimeout(() => {
        receiptList(pamar, receiptId).then((response) => {
          _this.orderReceiptList = response.data.data
          if (_this.orderReceiptList.total === 1) {
            // _this.filter = _this.orderReceiptList.records.map
            _this.getCarList(pamar.appId, {phone: _this.orderReceiptList.records[0].ownerPhone})
            _this.groupId = _this.orderReceiptList.records[0].groupId
            _this.isSecret = true
          } else {
            let maps = new Set()
            _this.orderReceiptList.records.map((item) => {
              maps.add(item.areaName)
              return Object.assign({}, {'text': item.areaName, 'value': item.areaName})
            })
            _this.filter = Array.from(maps).map((item) => {
              return Object.assign({}, {'text': item, 'value': item})
            })
            _this.carGroup = []
          }
          _this.loading = false
        })
      }, 500)
    },
    handleSizeChange (val) {
      this.orderReceipt.pageSize = val
      this.getList(this.orderReceipt)
    },
    getSummaries ({columns, data}) {
      if (data.length < 1) {
        return false
      }
      const sums = []
      // if (!this.isSecret && data.length > 1) {
      //   sums[0] = '当前页合计'
      //   sums[5] = '***'
      //   sums[8] = '***'
      //   return sums
      // }
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '当前页合计'
          return
        }
        if (index === 5) {
          const values = data.map(item => {
            return item.tonnage
          })
          let aa = values.reduce(function (prev, curr) {
            return prev + curr
          })
          sums[index] = aa.toFixed(1) + '吨'
          return
        }
        if (index === 8 && this.isSecret && data.length > 1) {
          const values = data.map(item => {
            return item.total
          })
          sums[index] = values.reduce(function (prev, curr) {
            return prev + curr
          }) + '元'
        }
      })
      return sums
    },
    handleCurrentChange (val) {
      this.orderReceipt.current = val
      this.getList(this.orderReceipt)
    },
    search () {
      this.orderReceipt.current = 1
      this.getList(this.orderReceipt)
    },
    print (id) {
      id.appId = this.appId
      localStorage.setItem('ldms_print', JSON.stringify(id))
      window.open(`/print.html`)
    },
    hideFold (id) {
      this.folds = false
      this.orderReceipt.current = 1
      if (typeof id === 'number') {
        this.getList(this.orderReceipt, id)
      }
    },
    group (data) {
      let _this = this
      clearTimeout(_this.timer)
      if (data.groupId == this.groupId) {
        _this.timer = setTimeout(() => {
          deleteCarGroup(this.appId, this.groupId, data.carId).then((response) => {
            data.groupId = data.carId
          })
        }, 300)
      } else {
        let carIds = [data.carId]
        _this.timer = setTimeout(() => {
          addCarGroup(this.appId, this.groupId, carIds).then((response) => {
            data.groupId = _this.groupId
          })
        }, 300)
      }
    }
  },
  components: {
    receiptOrder
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.box
  padding 18px
  background #fff
  border-radius 5px
  font-size 12px
  transition .3s
  box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232,237,250,0.5)
  .filter-item
    display: inline-block
    vertical-align: middle
    margin-bottom: 10px
    margin-right 5px
  .header
    font-size 12px !important
</style>
